import { render, staticRenderFns } from "./UserBalanceLogs.vue?vue&type=template&id=eca7aa32&"
import script from "./UserBalanceLogs.vue?vue&type=script&lang=js&"
export * from "./UserBalanceLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports